export default function criarAgendamentoPacoteDTO(form) {
  return {
    IDCADASTRO: Number(form.idCadastro),
    DIA_SEMANA: Number(form.diaSemana),
    CONDICAO: Number(form.condicao),
    IDESPECIALIDADE1: Number(form.idEspecialidade1),
    IDESPECIALIDADE2: form.idEspecialidade2
      ? Number(form.idEspecialidade2)
      : null,
    IDHORARIO: Number(form.idHorario),
    REPETIR_POR_MESES: Number(form.repetirPorMeses)
  };
}